//所有的常量配置

/**
 * @module config 项目中全局的配置
 * 
 * @baseUrl   请求的域名
 * @timeout   超时时间
*/
export default {
    baseUrl: 'https://bdtj.hxbdf120.com/server',
    //baseUrl: 'http://127.0.0.1:4004/server',
    timeout: 3000,
}